const SET_STATE_QUERY_PARAMS = 'SET_STATE_QUERY_PARAMS';

const defaultState = {
	queryParams: {}
};

export const reducer = (state = defaultState, action) => {
	switch (action.type) {
		case SET_STATE_QUERY_PARAMS:
			return Object.assign({}, state, { queryParams: action.params });
		default:
			return Object.assign({}, state);
	}
};